module.exports = __webpack_public_path__ + "media/images/athletes/2473-586c0a26da0d40b06806a7c01d85fb9f.png";